import { Dispatch, SetStateAction, useEffect } from 'react';
import { resolveSelectAllSelection } from '../utils/resolveSelectAllSelection';

export const useSelectedRowsBatchUpdate = (
  oldCachedQueryId: string | undefined,
  data: any[] | undefined,
  datasetData: any,
  selectAllChecked: boolean,
  deselectedRowIds: Set<string>,
  dataKey: string,
  selectedVirtualRows: number,
  setSelectedRowsCallback: Dispatch<SetStateAction<any[]>>,
  setSelectedVirtualRowsCallback: Dispatch<SetStateAction<number>>
) => {
  // Select-all is held as an exclusion set, so it has to be re-derived against
  // whatever is loaded now — a lazy append adds rows, a sort/filter/reload
  // replaces them outright and used to leave the selection pointing at the
  // previous ordering.
  useEffect(() => {
    //Omitting useEffect call
    if (
      datasetData?.lazy &&
      datasetData?.cachedQueryId !== oldCachedQueryId &&
      datasetData?.cachedQueryId !== undefined
    ) {
      return;
    }

    if (!data) return;

    const totalCount: number | undefined = datasetData?.totalCount;
    if (!totalCount) return;

    // The set outlives selectAllChecked (cleared on the first uncheck) and
    // selectedVirtualRows (drained to 0 once every page is loaded).
    const isSelectAllMode: boolean =
      selectAllChecked || selectedVirtualRows > 0 || deselectedRowIds.size > 0;
    if (!isSelectAllMode) return;

    const selection = resolveSelectAllSelection(
      data,
      totalCount,
      deselectedRowIds,
      dataKey
    );
    setSelectedRowsCallback(selection.selectedRows);
    setSelectedVirtualRowsCallback(selection.selectedVirtualRows);
  }, [data, datasetData]);
};
